import { Link } from "react-router-dom";
import { AppWrap } from "../wrapper";
import "./NotFound.scss"

const NotFound = () => {
    return (
        <div className="app__notfound">
            <h1>404</h1>
            <h2>Page Not Found</h2>
            <p>Oops! The page you are looking for does not exist.</p>
            <Link to="/" className="notfound-btn">
                Go Home
            </Link>
        </div>
    );
};
export default AppWrap(NotFound, "NotFound");
